import { BaseOption } from '@/hooks/useTypeToOptions';
import {
  useGetTargetApplicantsForInvoiceReportsHook,
  useGetTargetApplicantsForInvoiceReportsSuspenseInfinite,
} from 'ap-openapi';

export const useGetTargetApplicantsData = () => {
  const getTargetApplicantsApi = useGetTargetApplicantsForInvoiceReportsHook();

  const fetchTargetApplicants = async (
    memberIds: string[]
  ): Promise<BaseOption[]> => {
    if (memberIds.length === 0) return [];
    try {
      const response = await getTargetApplicantsApi({
        office_member_ids: memberIds,
        per: memberIds.length.toString(),
        page: '1',
        display_all_roles: true,
        include_agent_applicant: true,
      });

      if (response.data.office_members) {
        return response.data.office_members.map((member) => ({
          label: member.name ?? '',
          value: member.id ?? '',
          caption: member.number ?? '',
        }));
      }

      return [];
    } catch {
      return [];
    }
  };

  return {
    fetchTargetApplicants,
  };
};

type Params = {
  query?: string;
  per?: number;
  display_all_roles?: boolean;
  include_agent_applicant?: boolean;
};

export const useGetTargetApplicantsForInvoiceReports = ({
  query,
  per = 25,
  display_all_roles,
  include_agent_applicant,
}: Params) => {
  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetTargetApplicantsForInvoiceReportsSuspenseInfinite(
      {
        query,
        per: per.toString(),
        page: '1',
        ...(display_all_roles !== undefined && { display_all_roles }),
        ...(include_agent_applicant !== undefined && {
          include_agent_applicant,
        }),
      },
      {
        query: {
          getNextPageParam: (page) => {
            const next = page?.data?.next;
            if (!next) return undefined;
            try {
              const url = new URL(next, location.href);
              return url.searchParams.get('page') ?? undefined;
            } catch {
              return undefined;
            }
          },
        },
      }
    );
  if (error) throw error;
  return { data, fetchNextPage, hasNextPage, isFetchingNextPage };
};
